import { Button, Field, FieldError, Textarea } from "@/components/ui";
import { zodResolver } from "@hookform/resolvers/zod";
import type * as fhirTypes from "fhir/r4";
import { Controller, useForm } from "react-hook-form";
import type { z } from "zod";
import { editRecommendationSchema } from "./schema";

interface RecommendationEditorProps {
  onSubmit(v: z.infer<typeof editRecommendationSchema>): void;
  onCancel(): void;
  isSaving: boolean;
  task?: fhirTypes.Task;
}

export const RecommendationEditor = ({
  task,
  onCancel,
  onSubmit,
  isSaving,
}: RecommendationEditorProps) => {
  const form = useForm<z.infer<typeof editRecommendationSchema>>({
    resolver: zodResolver(editRecommendationSchema),
    defaultValues: {
      text: task?.description || "",
    },
  });

  return (
    <form
      onSubmit={form.handleSubmit(onSubmit)}
      className="mb-2"
      data-testid="edit-recommendation-form"
    >
      <Controller
        control={form.control}
        name="text"
        render={({ field, fieldState }) => (
          <Field className="col-span-2" data-invalid={fieldState.invalid}>
            <Textarea
              {...field}
              autoFocus
              data-testid="recommendation-text"
              rows={4}
              aria-invalid={fieldState.invalid}
            />
            <FieldError errors={[fieldState.error]} />
          </Field>
        )}
      />

      <div className="flex gap-2 ml-auto mt-2 w-fit">
        <Button
          size="xs"
          variant="secondary"
          onClick={onCancel}
          disabled={isSaving}
        >
          Cancel
        </Button>
        <Button size="xs" type="submit" isLoading={isSaving}>
          Save
        </Button>
      </div>
    </form>
  );
};
